import { useEffect, useState } from 'react';
import styled from '@emotion/styled'

import { Grid, Button } from '@mui/material'

import { Panel, SwitchSection, Section, HebrewSpan } from '../../Common'

import { usePageData } from '../../../../contexts/PageData';

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import GoogleIcon from '@mui/icons-material/Google';
import QuickbooksLogo from '../../../../images/QbLogo';

import { onlineManager, useQuery } from '@tanstack/react-query';

import { getSetting } from '../../apiService';

import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import LinkOffRoundedIcon from '@mui/icons-material/LinkOffRounded';

import Dialog from '../../../../utils/utilities/Dialog';

const Card = styled.div`
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: white;
`;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  /* margin-bottom: 24px; */
`;

const IconCircle = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.colors.successBg};
  flex-shrink: 0;
`;

const HeaderContent = styled.div`
  flex: 1;
`;

const Title = styled.h3`
  margin: 0 0 4px 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
`;

const Status = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #6b7280;
`;

const StatusDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${props => props.$disconnected ? '#d1d5db' : props.theme.colors.success};
`;

const Body = styled.div`
  margin-top: 2.4rem;
`

const Info = styled.p`
  padding: 1.6rem;
  line-height: 1.6;
  font-size: 1.6rem;
`


const Description = styled.p`
  margin: 0 0 28px 0;
  font-size: 15px;
  line-height: 1.6;
  color: #6b7280;
`;

const GoogleButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 0;
  background: white;
  border: 1px solid #dadce0;
  border-radius: 4px;
  cursor: pointer;
  font-family: 'Space Grotesk', 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #3c4043;
  transition: all 0.15s ease;
  overflow: hidden;

  &:hover {
    background: #f8f9fa;
    border-color: #d2d4d8;
    box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);
  }

  &:active {
    background: #f1f3f4;
    box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3);
  }
`;

const GoogleIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
`;

const ButtonText = styled.span`
  padding-right: 12px;
`;


const QuickbooksTab = () => {

  const [loadSetting, setLoadSetting] = useState(false);

  const { data } = usePageData() || {};

  console.log(data?.data, "data");

  const { data: setting, isLoading } = useQuery({
    queryKey: ['settings/accounting', 'quickbooks'],
    queryFn: () => getSetting(`settings/accounting`, `quickbooks`),
    enabled: !!data?.integration_id || loadSetting
  })

  console.log(setting, "setting");

  let settingsData = setting?.data || {};


useEffect(() => {
    // Listen for messages from popup
    const handleMessage = (event) => {
      // Security check - verify the message is from your backend
      // In production, check: if (event.origin !== 'https://yourapp.com') return;
      
      // console.log('Received message:', event.data);
      
      if (event.data.type === 'quickbooks_success') {
        console.log('Quickbooks connected successfully!');
        setLoadSetting(true);
        // Refresh integration status, show success message, etc.
        // fetchIntegrationStatus();
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

 const handleConnect = () => {
    // Popup dimensions
    const width = 760;
    const height = 600;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;

    // Open popup
    const popup = window.open(
      '/api/integrations/auth/quickbooks',
      'Quickbooks Integration Authorization',
      `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes,resizable=yes`
    );

    // Close after 10 seconds
    // setTimeout(() => {
    //   if (popup && !popup.closed) {
    //     popup.close();
    //   }
    // }, 10000);
  };

  return (
    // <Panel>

      <Card>
      <Header>
        <IconCircle>
          <AccountBalanceRoundedIcon color="success" />
        </IconCircle>
        <HeaderContent>
          <Title>Quickbooks Online</Title>
          <Status>
            <StatusDot $disconnected={!data?.integration_id} />
            {data?.integration_id ? 'Connected' : 'Not Connected'}
          </Status>
        </HeaderContent>
      </Header>

      {!data?.integration_id ? <Body>
        <Description>
          Sync Customers, Invoices, Expenses and Payments, etc. with your Quickbooks Online account.
        </Description>

        <GoogleButton onClick={handleConnect}>
          <GoogleIconWrapper>
            <QuickbooksLogo />
          </GoogleIconWrapper>
          <ButtonText>Sync your Quickbooks Online account</ButtonText>
        </GoogleButton>
        </Body>
        :
        <Body>
          <Dialog
            title="Disconnect Quickbooks"
            toggle={<Button startIcon={<LinkOffRoundedIcon />} variant="outlined" color="error">Disconnect Quickbooks</Button>}
            saveText="Disconnect"
          >
            <Info>
              If you proceed you will be disconnected from your Quickbooks Online account, and invoices, payments, etc. will no longer be synced. To reconnect, you will need to re-authorize your Quickbooks Online account. Continue?
            </Info>
          </Dialog>
        </Body>
      }
    </Card>

    // </Panel>
  )
};

export default QuickbooksTab;